import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import classnames from 'classnames';

import Button, { EditButton } from '@components/Button';
import Table from '@components/Table';

import { fetchViolationTypes } from '@actions/violationType';

import { violationTypesPartialURL } from '../AdminApp';

import ViolationTypeForm from './ViolationTypeForm';

import './style.scss';

interface IViolationTypeListingRow {
  id: number;
  label: string;
  iconUrl: string;
  status: string;
  associatedEntity: string;
}

interface IViolationTypesListingProps extends RouteComponentProps<{}> {
  violationTypes: ISystemXerceViolationTypeResponse[];
  fetchViolationTypes: TFetchViolationTypes;
}

interface IViolationTypesListingState {
  isViolationTypeFormOpen: boolean;
  rows: IViolationTypeListingRow[];
  editViolationTypeId: number;
}

class ViolationTypesListing extends React.Component<IViolationTypesListingProps, IViolationTypesListingState> {
  constructor(props: IViolationTypesListingProps) {
    super(props);

    this.state = {
      isViolationTypeFormOpen: false,
      rows: [],
      editViolationTypeId: null,
    };
  }

  componentDidMount() {
    const areViolationTypesPresent = !!this.props.violationTypes;
    const isViolationTypePath = this.props.location.pathname.includes(violationTypesPartialURL);

    if (!areViolationTypesPresent && isViolationTypePath) {
      this.props.fetchViolationTypes();
    } else if (areViolationTypesPresent) {
      this.setState({
        rows: this.getRows(this.props),
      });
    }
  }

  componentWillReceiveProps(nextProps: IViolationTypesListingProps) {
    const hasViolationTypesChanged: boolean = nextProps.violationTypes !== this.props.violationTypes;
    const hasPathChanged: boolean = this.props.location.pathname !== nextProps.location.pathname;
    const doViolationTypesExist = !!nextProps.violationTypes;

    if (hasPathChanged && !doViolationTypesExist) {
      this.props.fetchViolationTypes();
    }

    if (hasViolationTypesChanged) {
      this.setState({
        rows: this.getRows(nextProps),
      });
    }
  }

  getRows = (nextProps: IViolationTypesListingProps) => {
    const { violationTypes } = nextProps;

    return violationTypes.map((violationType) => ({
      id: violationType.id,
      label: violationType.label,
      iconUrl: violationType.iconUrl,
      status: violationType.isAvailableForActivation ? 'Available For Activation' : 'Unavailable for Activation',
      // TODO: replace once entity integration completed
      associatedEntity: violationType.associatedEntitySectionName ? violationType.associatedEntitySectionName : 'N/A',
    }));
  };

  toggleViolationTypeForm = (e: React.SyntheticEvent<HTMLElement>, violationTypeId?: number) => {
    const editViolationTypeId = violationTypeId ? violationTypeId : null;
    this.setState((prevState) => ({
      isViolationTypeFormOpen: !prevState.isViolationTypeFormOpen,
      editViolationTypeId,
    }));
  };

  renderTopBar = () => {
    const { violationTypes } = this.props;
    const violationTypesLength = violationTypes ? violationTypes.length : 0;

    return (
      <div className={classnames('violation-type-listing__table-top')}>
        <h2>{`${violationTypesLength} Violation Types`}</h2>
        <Button
          content={classnames('Create Violation Type')}
          bsStyle={ButtonStyle.PRIMARY}
          onClick={this.toggleViolationTypeForm}
        />
      </div>
    );
  };

  onViolationTypeFormClose = (e: React.SyntheticEvent<HTMLElement>) => this.toggleViolationTypeForm(e);

  onViolationTypeFormSubmit = (e: React.SyntheticEvent<HTMLElement>) => {
    this.onViolationTypeFormClose(e);
    this.props.fetchViolationTypes();
  };

  render() {
    const columns = [
      { accessor: 'label', Header: 'Agency Label', sortable: false },
      {
        accessor: 'iconUrl',
        Header: 'Icon',
        Cell: (row) => (
          <div className={classnames('icon-chooser')}>
            <div
              className={classnames('icon-chooser__icon')}
              style={{
                background: `url(${row.value}) center no-repeat`,
                height: '34px',
                width: '34px',
                maxWidth: '34px',
                maxHeight: '34px',
              }}
            />
          </div>
        ),
        sortable: false,
      },
      {
        accessor: 'status',
        Header: 'Status',
        sortable: false,
      },
      {
        accessor: 'associatedEntity',
        Header: 'Associated Entity',
        sortable: false,
      },
      {
        accessor: '',
        Header: '',
        Cell: (cell) => <EditButton onClick={(e) => this.toggleViolationTypeForm(e, cell.original.id)} />,
        sortable: false,
        width: 50,
      },
    ];

    return (
      <div className={classnames('violation-type-listing')}>
        <Table columns={columns} rows={this.state.rows} customTopBar={this.renderTopBar()} plainTable={true} />
        <ViolationTypeForm
          show={this.state.isViolationTypeFormOpen}
          onClose={this.onViolationTypeFormClose}
          onSubmit={this.onViolationTypeFormSubmit}
          violationTypeId={this.state.editViolationTypeId}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxStore) => ({
  violationTypes: state.violationType.systemViolationTypes,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchViolationTypes: () => dispatch(fetchViolationTypes()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViolationTypesListing));
